module.exports = __webpack_public_path__ + "img/img93.4cb35f1a.svg";